import { render, staticRenderFns } from "./data42.vue?vue&type=template&id=2399c42a&scoped=true&"
import script from "./data42.vue?vue&type=script&lang=js&"
export * from "./data42.vue?vue&type=script&lang=js&"
import style1 from "./data42.vue?vue&type=style&index=1&id=2399c42a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2399c42a",
  null
  
)

export default component.exports